import { createFileRoute } from '@tanstack/react-router';

import { InternalUserRequired } from '@/features/login/ui';
import { InternalWorkspaceLayout } from '@/internal/app/internal-workspace-layout';

import { PageLoader } from '@/shared/components/loader/page-loader';
import { ScrapingPage } from '@/internal/scraping/scraping-page';

export const Route = createFileRoute('/scraping')({
  component: () => (
    <InternalUserRequired pendingFallback={<PageLoader />}>
      <InternalWorkspaceLayout>
        <ScrapingPage />
      </InternalWorkspaceLayout>
    </InternalUserRequired>
  ),
});
